import React, { ReactElement } from 'react';
import DocumentItem, {
    LINK_TYPE,
} from 'components/pages/documents/DocumentItem';
import { useMenuConfig } from 'components/pages/base/menu/useMenuConfig';
import { getTranslation, useTranslation } from 'utils/localization';
import { TNamespaceEnum } from 'types/types';

const DocumentsBlock = (): ReactElement => {
    const { is1Url } = useMenuConfig();
    const { t } = useTranslation();

    return (
        <ul>
            <DocumentItem
                url="/uzivatelska_prirucka.pdf"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                <strong>
                    {getTranslation(t, TNamespaceEnum.document, 'userManual')}
                </strong>
            </DocumentItem>
            <DocumentItem
                url="/FAQ.pdf"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                <strong>
                    {getTranslation(t, TNamespaceEnum.document, 'faq')}
                </strong>
            </DocumentItem>
            <DocumentItem
                url="/document/download/74368"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'matchDate')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74369"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'notifications')}
            </DocumentItem>
            <DocumentItem
                url="/files/Vyzadani_hrace_ze_zahranici.pdf"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                {getTranslation(t, TNamespaceEnum.document, 'foreignPlayer')}
            </DocumentItem>
            <DocumentItem
                url="/dokumenty/zadost_o_uvolneni.pdf"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'homePlayerToForeign'
                )}
            </DocumentItem>
            <DocumentItem
                url="/files/Pruvodce_podani_zadosti_o_zahranicni_prestup_nezletilych_hracu.pdf"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'foreignYoungPlayerManual'
                )}
            </DocumentItem>
            <DocumentItem
                url="/files/Zadost_o_registraci_hrace_(cizince)_mladsiho_10_let.pdf"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'foreignYoungRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74371"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'noUseByHomeClub')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74372"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'onlineTransfer')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74373"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'onlinePlayerRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74374"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'studyConfirmation'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74375"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'transferTicket')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74376"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'otherLegalPersonRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74377"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'clubRegistration')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74378"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'administratorRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/files/registrace-povereneho-administratora-navod_n.pdf"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'viceAdministratorRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74380"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'playerAgreement')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74381"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'playerList')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74382"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(t, TNamespaceEnum.document, 'photoAdd')}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74384"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'mainAdminClubRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74385"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'memberRegistrationChange'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74386"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'cancelRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74387"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'cancelPlayerRegistrationByClub'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74388"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'cancelMemberRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/document/download/74389"
                linkType={LINK_TYPE.FACR_WEB}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'cancelClubRegistration'
                )}
            </DocumentItem>
            <DocumentItem
                url="/dokumenty/Ukonceni_clenstvi.docx"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                {getTranslation(t, TNamespaceEnum.document, 'membershipCancel')}
            </DocumentItem>
            <DocumentItem
                url="/dokumenty/ukvolprest.docx"
                is1Url={is1Url}
                linkType={LINK_TYPE.IS1}
            >
                {getTranslation(
                    t,
                    TNamespaceEnum.document,
                    'freeTransferCancellation'
                )}
            </DocumentItem>
        </ul>
    );
};

export default DocumentsBlock;
